import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import Portfolio from './components/Portfolio';
import AdminLogin from './components/admin/AdminLogin';
import AdminDashboard from './components/admin/AdminDashboard';
import ProtectedRoute from './components/admin/ProtectedRoute';
import BabyTrackPrivacy from './components/BabyTrackPrivacy';
import BabyTrackSupport from './components/BabyTrackSupport';
import WealthTrackerPrivacy from './components/WealthTrackerPrivacy';
import WealthTrackerSupport from './components/WealthTrackerSupport';
import StreaksPrivacy from './components/StreaksPrivacy';
import StreaksSupport from './components/StreaksSupport';
import NovaCyclePrivacy from './components/NovaCyclePrivacy';
import NovaCycleSupport from './components/NovaCycleSupport';
import RecallPrivacy from './components/RecallPrivacy';
import RecallSupport from './components/RecallSupport';
import ChessMatePrivacy from './components/ChessMatePrivacy';
import ChessMateSupport from './components/ChessMateSupport';
import DriftPrivacy from './components/DriftPrivacy';
import DriftSupport from './components/DriftSupport';
import CooksmithPrivacy from './components/CooksmithPrivacy';
import CooksmithSupport from './components/CooksmithSupport';
import PomogrowPrivacy from './components/PomogrowPrivacy';
import PomogrowSupport from './components/PomogrowSupport';
import QuenchPrivacy from './components/QuenchPrivacy';
import QuenchSupport from './components/QuenchSupport';
import DocketPrivacy from './components/DocketPrivacy';
import DocketSupport from './components/DocketSupport';
import GenericPrivacyPage from './components/GenericPrivacyPage';
import GenericSupportPage from './components/GenericSupportPage';
import GenericTermsPage from './components/GenericTermsPage';
import { appPageData } from './data/appPageData';
import { appTermsData } from './data/appTermsData';
import ScrollToTop from './components/ScrollToTop';

const genericSlugs = [
  '2048',
  'brain-grid',
  'ember',
  'date-tracker',
  'wolfvpn',
  'spam-blocker',
  'kingdom-siege',
  'powderlog',
  'hipoapp',
];

function Shell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  return (
    <div className="App">
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<HomePage />} />
        <Route path="/portfolio" element={<Portfolio />} />
          {/* Custom pages */}
          <Route path="/babytrack/privacy" element={<BabyTrackPrivacy />} />
          <Route path="/babytrack/support" element={<BabyTrackSupport />} />
          <Route path="/wealthtracker/privacy" element={<WealthTrackerPrivacy />} />
          <Route path="/wealthtracker/support" element={<WealthTrackerSupport />} />
          <Route path="/streaks/privacy" element={<StreaksPrivacy />} />
          <Route path="/streaks/support" element={<StreaksSupport />} />
          <Route path="/nova-cycle/privacy" element={<NovaCyclePrivacy />} />
          <Route path="/nova-cycle/support" element={<NovaCycleSupport />} />
          <Route path="/recall/privacy" element={<RecallPrivacy />} />
          <Route path="/recall/support" element={<RecallSupport />} />
          <Route path="/chessmate/privacy" element={<ChessMatePrivacy />} />
          <Route path="/chessmate/support" element={<ChessMateSupport />} />
          <Route path="/drift/privacy" element={<DriftPrivacy />} />
          <Route path="/drift/support" element={<DriftSupport />} />
          <Route path="/cooksmith/privacy" element={<CooksmithPrivacy />} />
          <Route path="/cooksmith/support" element={<CooksmithSupport />} />
          <Route path="/pomogrow/privacy" element={<PomogrowPrivacy />} />
          <Route path="/pomogrow/support" element={<PomogrowSupport />} />
          <Route path="/quench/privacy" element={<QuenchPrivacy />} />
          <Route path="/quench/support" element={<QuenchSupport />} />
          <Route path="/docket/privacy" element={<DocketPrivacy />} />
          <Route path="/docket/support" element={<DocketSupport />} />
          {/* Generic pages */}
          {genericSlugs.map(slug => {
            const data = appPageData[slug];
            return [
              <Route key={`${slug}-privacy`} path={`/${slug}/privacy`} element={<GenericPrivacyPage appData={data} />} />,
              <Route key={`${slug}-support`} path={`/${slug}/support`} element={<GenericSupportPage appData={data} />} />,
            ];
          })}
          {/* Terms of Use — covers Apple Guideline 3.1.2 (subscription EULA) for every app */}
          {Object.values(appTermsData).map(data => (
            <Route key={`${data.slug}-terms`} path={`/${data.slug}/terms`} element={<GenericTermsPage appData={data} />} />
          ))}
      </Routes>
      {!isAdmin && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Shell />
    </Router>
  );
}

export default App;
